import Messages from "./Messages"
import Settings from './Settings'
import Participants from './Participants'

export const Modals = {
    Messages, Settings, Participants
}